<template>
    <div>
        <div class="container">
            <div class="d-flex"> 
                <div  class="btn-home-2 mb-4 mt-3 ms-auto">
                    <button type="button" class="btn btn-outline-main" @click="returnHome">
                        <i class="fas fa-home-lg-alt"></i> Inicio
                    </button>
                </div>
            </div>
            <div id="div-modal-cxc" class="d-flex justify-content-center">
                <div id="div-cxc" class="card w-100">
                    <div class="card-header text-white h4 text-center bg-main">
                        <strong>STOCK</strong>
                    </div>
                    <div class="card-body w-100 mt-2 mb-2 px-4">
                        <div class="row d-flex">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div class="card stock-card-se">
                                    <div class="card-header d-flex justify-content-between text-white bg-main">
                                        <span><i class="fas fa-box"></i>&nbsp; <strong>PRODUCTO</strong></span>
                                    </div>
                                    <div class="card-body mb-2">
                                        <div class="row d-flex">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                                                <v-select
                                                    class="text-dark form-control"
                                                    label="name"
                                                    :options="prodOptions"
                                                    placeholder="Seleccione un Producto"
                                                    @search="mtdGetProd"
                                                    v-model="selectedProd"
                                                    :reduce="(name) => name.id"
                                                    required
                                                    :clearable="false"
                                                    @input="mtdGetData"
                                                >
                                                    <template slot="no-options">
                                                    No hay Productos para la busqueda
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-2">
                                <div class="card stock-card">
                                    <div class="card-header text-white bg-main">
                                        <strong>Detalles del Producto</strong>
                                    </div>
                                    <div class="card-body text-center">
                                        <h5 v-if="data.name">{{ data.name }}</h5>
                                        <p class="stock-text" v-if="data.stock !== undefined && data.stock > 0">
                                            Stock: <span class="stock-value">{{ parseInt(data.stock) }}</span>
                                        </p>
                                        <p v-else-if="data.stock === 0">No hay stock</p>
                                        <p v-else>Sin Stock Disponible</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";

export default {
  name: "c-pages-stock",
  components: {
    SweetAlert,
  },
  data() {
    return {
      swal: null,
      search: "",
      data: [],
      dataShow: [],
      showTable: false,
      selectedProd: "",
      prodOptions: [],
      //Pag
      page: 0,
      selectPage: 1,
      stepPagination: [],
      totalPagesToShow: 4,
    };
  },
  created() {
  },
  watch: {
    selectPage() {
      this.calculateData(10);
    },
  },
  computed: {
    cpData() {
      return this.dataShow;
    },

    limitedStepPagination() {
      const totalPages = this.stepPagination.length;
      const currentPage = this.selectPage;

      let startPage = 1;
      let endPage = totalPages;
      if (totalPages > this.totalPagesToShow) {
        const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

        if (currentPage > halfPagesToShow) {
          startPage = currentPage - halfPagesToShow;
          endPage = currentPage + halfPagesToShow - 1;

          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = totalPages - this.totalPagesToShow + 1;
          }
        } else {
          endPage = this.totalPagesToShow;
        }
      }

      return Array.from(
        {
          length: endPage - startPage + 1,
        },
        (_, i) => startPage + i
      );
    },
  },
  methods: {
    ...mapActions(["get", "post"]),

    returnHome: function () {
      this.$emit("returnHome");
    },

    mtdGetProd: function (search, loading) {
        if (search.length > 2) {
            this.prodOptions = [];
            this.selectedProd =  "",
            loading(true);
            this.get({
                url: this.$store.getters.get__url + "/Logis/purchase/mtdGetProd",
                token: this.$store.getters.get__token,
            })
            .then((response) => {
                this.prodOptions = response.data;
                loading(false);
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        }
    },

    mtdGetData: function () {
        this.data = [];
        this.get({
            url: this.$store.getters.get__url + "/Logis/purchase/productStock/" + this.selectedProd,
            token: this.$store.getters.get__token,
        })
        .then((response) => {
            if(response.data !== null){
                this.data = response.data;
                this.showTable = true;
            }else{
                this.showTable = false;
                this.$refs.SweetAlert.showWarning("Sin Stock");
            }
        })
        .catch((errors) => {
            this.$refs.SweetAlert.showError(errors);
        });
    },
    
    /** paginación */
    backPage() {
      this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
    },
    nextPage() {
      this.selectPage =
        this.selectPage < this.stepPagination.length
          ? this.selectPage + 1
          : this.stepPagination.length;
    },
    selectedPage(page) {
      this.selectPage = page;
    },
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
    formatDateTime(dateTime) {
      return dateTime != null ? moment(dateTime).format("DD/MM/YYYY HH:mm") : "-";
    },
  },
};
</script>
<style scoped>
.stock-card {
  background-color: #f8f9fa; 
  border: 1px solid #2c3c5c; 
  border-radius: 8px; 
  transition: transform 0.2s; 
}

.stock-card-se {
  background-color: #f8f9fa; 
  border: 1px solid #2c3c5c; 
  border-radius: 8px; 
}

.stock-card:hover {
  transform: scale(1.02); 
}

.stock-text {
  font-size: 1.25rem; 
  font-weight: bold;
}

.stock-value {
  color: #2c3c5c; 
  font-size: 1.5rem; 
}
</style>